
import { useState, useEffect } from "react";

interface UseAccountStateProps {
  profileLoading: boolean;
  subscriptionLoading: boolean;
}

export const useAccountState = ({
  profileLoading,
  subscriptionLoading
}: UseAccountStateProps) => {
  const [loading, setLoading] = useState(true);
  
  // Update the loading state when both profile and subscription data are loaded
  useEffect(() => {
    setLoading(profileLoading || subscriptionLoading);
  }, [profileLoading, subscriptionLoading]);
  
  return { loading };
};
